/**
 * The user's own choice of My tasks version, and whether they have seen the note that
 * comes with the new one. Delete this file with the flag, together with its only outside
 * reader, utils/survicate.function.ts.
 */

export const BETA_STORAGE_KEY = '@@myTasks/beta';

/**
 * the version the user picked with the Beta switch; null = never picked one
 */
export function readStoredBeta(storage: Storage = window.localStorage): boolean | null {
    try {
        const raw = storage.getItem(BETA_STORAGE_KEY);
        if (raw === 'true') return true;
        if (raw === 'false') return false;
        return null;
    } catch (e) {
        return null;
    }
}

export function writeStoredBeta(enabled: boolean, storage: Storage = window.localStorage): void {
    try {
        storage.setItem(BETA_STORAGE_KEY, String(enabled));
    } catch (e) {
        // a full or blocked storage must not break the switch
    }
}

export const BETA_INTRO_STORAGE_KEY = '@@myTasks/betaIntroSeen';

/**
 * the beta intro repeats on every switch-on until the user opts out of it
 */
export function hasSeenBetaIntro(storage: Storage = window.localStorage): boolean {
    try {
        return storage.getItem(BETA_INTRO_STORAGE_KEY) === 'true';
    } catch (e) {
        // without storage there is no way to remember it, and showing it on every switch is worse
        return true;
    }
}

export function markBetaIntroSeen(storage: Storage = window.localStorage): void {
    try {
        storage.setItem(BETA_INTRO_STORAGE_KEY, 'true');
    } catch (e) {
        // a full or blocked storage must not break the switch
    }
}
